import React from 'react';
import { NewText, ReadMoreIcon } from 'ui';
import WhatsupIcons from 'ui/icons/WhatsappIcon';
import TabPanel from 'ui/TabPanel';
import { ButtonLayout, StyledTabPanelWrapper } from '../styles';

type CustomerServiceTabProps = {
    tabIndex: number;
    textLine: string;
    button: any
};
const CustomerServiceTab: React.FC<CustomerServiceTabProps> = ({ tabIndex, textLine, button }) => {

    return (
        <TabPanel value={tabIndex} index={0}>
            <StyledTabPanelWrapper>
                <ButtonLayout href={button?.url}>
                    <WhatsupIcons />
                    <span>{button?.name}</span>
                    <ReadMoreIcon color="white" />
                </ButtonLayout>
                <NewText
                    component={"p"}
                    largeDesktopFontSize={18}
                    desktopFontSize={18}
                    desktopLineHeight={"140%"}
                    mobileFontSize={18}
                    mobileLineHeight={"24px"}
                    desktopFontWeight={400}
                    mobileFontWeight={400}
                    dangerouslySetInnerHTML={{ __html: textLine }}
                ></NewText>
            </StyledTabPanelWrapper>

        </TabPanel>
    );
};
export default CustomerServiceTab;
